import styled from "styled-components";
import fonts, { fontWeights } from "styles/fonts";

export const StyledErrorMessage = styled.p`
  font-size: ${fonts.small};
  font-weight: ${fontWeights.semiBold};
  margin-left: 1em;
`;
